import React from 'react';
// TODO: move this to constant file
var UPS_LOGO_SRC = 'https://assets.thdstatic.com/images/v1/shipping-carriers/ups-logo.svg';
var FEDEX_LOGO_SRC = 'https://assets.thdstatic.com/images/v1/shipping-carriers/FEDEX.png';
var ESTES_LOGO_SRC = 'https://assets.thdstatic.com/images/v1/shipping-carriers/Estes.png';
var ONTRAC_LOGO_SRC = 'https://assets.thdstatic.com/images/v1/shipping-carriers/ontrac.svg';
var SEKO_LOGO_SRC = 'https://assets.thdstatic.com/images/v1/shipping-carriers/seko.png';
var YRC_LOGO_SRC = 'https://assets.thdstatic.com/images/v1/shipping-carriers/YRC_Freight.png';
var USPS_LOGO_SRC = 'https://assets.thdstatic.com/images/v1/shipping-carriers/usps-logo.svg';
var US_PACK_LOGO_SRC = 'https://assets.thdstatic.com/images/v1/shipping-carriers/USPack.png';
export var trackingProviderImages = function (providerCode) {
    switch (providerCode) {
        case 'UPS':
        case 'UPS1':
        case 'UPSC':
        case 'UPSN':
            return UPS_LOGO_SRC;
        case 'USPS':
            return USPS_LOGO_SRC;
        case 'BESY':
            return US_PACK_LOGO_SRC;
        case 'FEDEX':
        case 'FED':
        case 'FDEG':
        case 'FDEN':
        case 'FEDE':
        case 'FXHD':
        case 'FXNL':
        case 'FXSP':
            return FEDEX_LOGO_SRC;
        case 'EST':
        case 'EXLA':
            return ESTES_LOGO_SRC;
        case 'ONT':
        case 'EMSY':
            return ONTRAC_LOGO_SRC;
        case 'SEK':
        case 'SEKW':
            return SEKO_LOGO_SRC;
        case 'YRC':
        case 'RWY':
        case 'YFSY':
            return YRC_LOGO_SRC;
        default:
            return null;
    }
};
export var getProviderImage = function (providerCode) {
    var provider = trackingProviderImages(providerCode);
    // TODO: fix the imageWidth by changing the static images on thd-static-assets which has same sizes. Currently, UPS Logo is larger than any other logo's available
    var imageWidth = ['UPS', 'UPS1', 'UPSC', 'UPSN'].some(function (code) {
        return providerCode.includes(code);
    })
        ? '10%'
        : '20%';
    if (!provider) {
        return null;
    }
    return (React.createElement("img", { height: "24px", width: imageWidth, alt: "shipping-carrier-logo", src: provider }));
};
